import React from "react";
import loadjs from "loadjs";
import * as serviceWorker from "./serviceWorker";
import ProtectedRoute from "./comman/protectedRoute";
import Logout from "./components/Logout";
import App from "./App";
import { msalConfig } from "./authConfig";
import { getAlert } from "./services/appAlerts";
import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import "./index.css";
import "./App.css";
import "./common-table.css";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Provider } from "react-redux";
import store, { persistor } from "./app/store/configureStore";

// Global window.alert override to use SweetAlert
window.alert = (message) => {
  const isDenied = message && typeof message === "string" && message.toLowerCase().includes("denied");
  getAlert(isDenied ? "Access Denied" : "", String(message), isDenied ? "error" : "info");
};

const pca = new PublicClientApplication(msalConfig);

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Provider store={store}>
      <MsalProvider instance={pca}>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </MsalProvider>
    </Provider>
  </BrowserRouter>,
);
serviceWorker.unregister();
